const Utils = {
  getParam(sname) {
    var params = window.location.search.substring(window.location.search.indexOf("?") + 1);
    var sval = "";
    params = params.split("&");
    let temp
    for (var i = 0; i < params.length; i++) {
      temp = params[i].split("=");
      if ([temp[0]] == sname) { sval = temp[1]; }
    }
    return sval;
  },

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  },

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min; //최댓값은 제외, 최솟값은 포함
  },

  getRandomNumbers(count, min, max) {
    const numbers = new Set();
    while (numbers.size < count) {
      const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
      numbers.add(randomNum);
    }
    return Array.from(numbers);
  },

  makeCode(scriptNo, heroNo) {
    return `${scriptNo}d${heroNo || 1}`
  },

  getFromCode(code) {
    const regex = code.match(/^(\d+)\D+(\d+)$/);
    return {
      scriptNo: Number(regex[1]),
      heroNo: Number(regex[2])
    }
  },

  isSampleScript(script) {
    return Boolean(script?.defaultStory) || script?.scriptImageCreated === false
  }

}

export default Utils
